var youTubeReady = false;

window.onYouTubeIframeAPIReady = function() {
    youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
}

var mixin = {
    utils: {},
    YouTube: (function() {
        var classes = {
          loading: 'loading',
          loaded: 'loaded',
          interactable: 'video-interactable'
        }
      
        var defaults = {
          width: 1280,
          height: 720,
          playerVars: {
            autohide: 0,
            autoplay: 0,
            cc_load_policy: 0,
            controls: 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 0,
            rel: 0
          },
          style: "sound"
        };
      
        function YouTube(divId, options) {
          this.divId = divId;
          this.iframe = null;
      
          this.attemptedToPlay = false;
      
          // API callback events
          defaults.events = {
            onReady: this.onVideoPlayerReady.bind(this),
            onStateChange: this.onVideoStateChange.bind(this)
          };
      
          this.options = Object.assign({}, defaults, options);
          
          if (this.options) {
            if (this.options.videoParent) {
                this.parent = document.getElementById(this.divId).parentNode;
            }
      
            // Most YT videos will autoplay. If in product media,
            // will handle in theme.Product instead
            if (!this.options.autoplay) {
              this.options.playerVars.autoplay = this.options.autoplay;
            }
            
            if (this.options.style === 'sound') {
              this.options.playerVars.controls = 1;
              this.options.playerVars.autoplay = 0;
            }
          }
      
          this.setAsLoading();
      
          if (youTubeReady) {
            this.init();
          } else {
            mixin.LibraryLoader.load('youtubeSdk');
            document.addEventListener('youTubeReady', this.init.bind(this));
          }
        }
      
        YouTube.prototype = Object.assign({}, YouTube.prototype, {
          init: function() {
            console.log(this.options);
            this.videoPlayer = new YT.Player(this.divId, this.options);
          },
      
          onVideoPlayerReady: function(evt) {
            this.iframe = document.getElementById(this.divId); // iframe once YT loads
            this.iframe.setAttribute('tabindex', '-1');
      
            if (this.options.style !== 'sound') {
              evt.target.mute();
            }
      
            // pause when out of view
            var observer = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  // this.play();
                } else {
                  this.pause();
                }
              });
            }, {rootMargin: '0px 0px 50px 0px'});
      
            observer.observe(this.iframe);
          },
      
          onVideoStateChange: function(evt) {
            console.log(evt);
            switch (evt.data) {
              case -1: // unstarted
                // Handle low power state on iOS by checking if
                // video is reset to unplayed after attempting to buffer
                if (this.attemptedToPlay) {
                  this.setAsLoaded();
                  this.enableInteraction();
                }
                break;
              case 0: // ended, loop it
                // this.play(evt);
                break;
              case 1: // playing
                this.setAsLoaded();
                break;
              case 3: // buffering
                this.attemptedToPlay = true;
                break;
            }
          },
      
          setAsLoading: function() {
            if (!this.parent) return;
            this.parent.classList.add(classes.loading);
          },
      
          setAsLoaded: function() {
            if (!this.parent) return;
            this.parent.classList.remove(classes.loading);
            this.parent.classList.add(classes.loaded);
            if (Shopify && Shopify.designMode) {
              if (window.AOS) {AOS.refreshHard()}
            }
          },
      
          enableInteraction: function() {
            if (!this.parent) return;
            this.parent.classList.add(classes.interactable);
          },
      
          play: function() {
            if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
              this.videoPlayer.playVideo();
              console.log("test");
            }
          },
      
          pause: function() {
            if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
              this.videoPlayer.pauseVideo();
            }
          },
      
          destroy: function() {
            if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
              this.videoPlayer.destroy();
            }
          }
        });
      
        return YouTube;
    })(),
    LibraryLoader: (function() {
        var types = {
          link: 'link',
          script: 'script'
        };
      
        var status = {
          requested: 'requested',
          loaded: 'loaded'
        };
      
        var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
      
        var libraries = {
          youtubeSdk: {
            tagId: 'youtube-sdk',
            src: 'https://www.youtube.com/iframe_api',
            type: types.script
          },
          vimeo: {
            tagId: 'vimeo-api',
            src: 'https://player.vimeo.com/api/player.js',
            type: types.script
          },
          shopifyXr: {
            tagId: 'shopify-model-viewer-xr',
            src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
            type: types.script
          },
          modelViewerUi: {
            tagId: 'shopify-model-viewer-ui',
            src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
            type: types.script
          },
          modelViewerUiStyles: {
            tagId: 'shopify-model-viewer-ui-styles',
            src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
            type: types.link
          }
        };
      
        function load(libraryName, callback) {
          var library = libraries[libraryName];
      
          if (!library) return;
          if (library.status === status.requested) return;
      
          callback = callback || function() {};
          if (library.status === status.loaded) {
            callback();
            return;
          }
      
          library.status = status.requested;
      
          var tag;
      
          switch (library.type) {
            case types.script:
              tag = createScriptTag(library, callback);
              break;
            case types.link:
              tag = createLinkTag(library, callback);
              break;
          }
      
          tag.id = library.tagId;
          library.element = tag;
      
          var firstScriptTag = document.getElementsByTagName(library.type)[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
      
        function createScriptTag(library, callback) {
          var tag = document.createElement('script');
          tag.src = library.src;
          tag.addEventListener('load', function() {
            library.status = status.loaded;
            callback();
          });
          return tag;
        }
      
        function createLinkTag(library, callback) {
          var tag = document.createElement('link');
          tag.href = library.src;
          tag.rel = 'stylesheet';
          tag.type = 'text/css';
          tag.addEventListener('load', function() {
            library.status = status.loaded;
            callback();
          });
          return tag;
        }
      
        return {
          load: load
        };
    })()
}

class VideoHeader extends HTMLElement {
    constructor() {
        super();

        var DataDiv = this.querySelector('.video-div');
        if (!DataDiv) {
            return;
        }
        var type = DataDiv.dataset.type;
        switch(type) {
            case 'youtube':
              var videoId = DataDiv.dataset.videoId;
              this.initYoutubeVideo(videoId, this, DataDiv.dataset.sectionId);
              break;
            case 'vimeo':
              var videoId = DataDiv.dataset.videoId;
              this.initVimeoVideo(videoId, this, DataDiv.dataset.sectionId);
              break;
            case 'mp4':
              this.initMp4Video();
              break;
          }
    }
    initYoutubeVideo (videoId, container, sectionId) {
        this.videoObject = new mixin.YouTube(
            'YouTubeVideo-' + sectionId,
            {
                videoId: videoId,
                videoParent: container.querySelector('.video-section')
            }
        );
    }
  
    initVimeoVideo (videoId, container, sectionId) {
        this.videoObject = new theme.VimeoPlayer(
            'Vimeo-' + sectionId,
            videoId,
            {
                videoParent: container.querySelector('.video-section')
            }
        );
    }
  
    initMp4Video () {
      var mp4Video = 'Mp4Video-' + this.sectionId;
      var mp4Div = document.getElementById(mp4Video);

      if (mp4Div) {
        parent.classList.add('loaded');

        var playPromise = document.querySelector('#' + mp4Video).play();

        // Edge does not return a promise (video still plays)
        if (playPromise !== undefined) {
          playPromise.then(function() {
              // playback normal
            }).catch(function() {
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
        }
      }
    }
}

customElements.define("video-header", VideoHeader);

class TermsAndConditions extends HTMLElement {
    constructor() {
        super();      
      	this.Binds();
    }
  
    Binds () {
      var self = this;
      if (this.closest("#CartDrawer") != null) {
         this.closest("#CartDrawer").querySelector('.cart__checkout-button').addEventListener("click", function (event) {
          if (!this.closest("#CartDrawer").querySelector('#enable_terms').checked) {
            event.preventDefault(); 
            
            var container = this.closest("#CartDrawer").querySelector('#enable_terms').parentNode.parentNode;
            
            if (container.querySelector('.error') == null) {
              var error = document.createElement('p');
              error.classList.add('error');
              error.innerHTML = "Dette felt er påkrævet";
              container.appendChild(error);
              
              if (!self.is_terms_bound) {
                this.closest("#CartDrawer").querySelector('#enable_terms').addEventListener('change', function () {
                  if (container.querySelector('.error')) {
                    container.querySelector('.error').parentNode.removeChild(container.querySelector('.error'));
                  }
                }, true);
                self.is_terms_bound = true;
              }
            }
          } 
        }); 
      } else if (this.closest(".cart__blocks") != null) {
        this.closest(".cart__blocks").querySelector('.cart__checkout-button').addEventListener("click", function (event) {
          if (!this.closest(".cart__blocks").querySelector('#enable_terms').checked) {
            event.preventDefault(); 
            
            var container = this.closest(".cart__blocks").querySelector('#enable_terms').parentNode.parentNode;
            
            if (container.querySelector('.error') == null) {
              var error = document.createElement('p');
              error.classList.add('error');
              error.innerHTML = "Dette felt er påkrævet";
              container.appendChild(error);
              
              if (!self.is_terms_bound) {
                this.closest(".cart__blocks").querySelector('#enable_terms').addEventListener('change', function () {
                  if (container.querySelector('.error')) {
                    container.querySelector('.error').parentNode.removeChild(container.querySelector('.error'));
                  }
                }, true);
                self.is_terms_bound = true;
              }
            }
          } 
        }); 
      }
    }
}

customElements.define("terms-and-conditions", TermsAndConditions);

if (document.querySelector(".video_banner_cta") != null) {
  document.querySelector(".video_banner_cta").addEventListener("click", function (evt) {
    evt.preventDefault();
    document.querySelector(evt.target.dataset.id).scrollIntoView({
      behavior: 'smooth', // smooth scroll
      block: 'start' // the upper border of the element will be aligned at the top of the visible part of the window of the scrollable area.
    })
  });
}